import * as THREE from "three";

export type Engine = {
  scene: THREE.Scene;
  camera: THREE.PerspectiveCamera;
  renderer: THREE.WebGLRenderer;
  canvas: HTMLCanvasElement;
  ambientLight: THREE.AmbientLight;
  directionalLight: THREE.DirectionalLight;
  dispose: () => void;
};

export function createEngine(canvas: HTMLCanvasElement): Engine {
  // Scene
  const scene = new THREE.Scene();
  scene.background = new THREE.Color(0x87ceeb); // sky blue
  scene.fog = new THREE.Fog(0x87ceeb, 60, 140);

  // Camera
  const camera = new THREE.PerspectiveCamera(
    75,
    window.innerWidth / window.innerHeight,
    0.1,
    500
  );
  camera.position.set(0, 80, 0);

  // Renderer
  const renderer = new THREE.WebGLRenderer({
    canvas,
    antialias: false, // perf — voxels don't need AA
    powerPreference: "high-performance",
  });
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.shadowMap.enabled = false; // disable for now (perf)

  // Lighting
  const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
  scene.add(ambientLight);

  const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
  directionalLight.position.set(100, 200, 50);
  scene.add(directionalLight);

  // Handle resize
  const handleResize = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
    renderer.setSize(width, height);
  };
  window.addEventListener("resize", handleResize);

  const dispose = () => {
    window.removeEventListener("resize", handleResize);
    renderer.dispose();
  };

  return {
    scene,
    camera,
    renderer,
    canvas,
    ambientLight,
    directionalLight,
    dispose,
  };
}
